import type { FaireProductEntity } from "../../entity_types/product";

export const p_hr2c2qxn5f: FaireProductEntity = {
  token: "p_hr2c2qxn5f",
  type: "product",
  name: "Zircon inlaid chain Fringe 18K Golden SS huggie Earrings-FGS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/b8997a3871a2140547c41e5da5d3cd7ce15896d7ac6afe447758fbf690d4677b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0a3c5b5b52f6b452ccd9cebb0fcf8795011fe79d3d03af57d95b95e26bf47582.jpeg",
    "https://cdn.faire.com/fastly/7fbe36286ffa27b05c5aab897c2a4adcb6fc28b11250eb704fdd7c35fa075791.jpeg",
    "https://cdn.faire.com/fastly/339655cf6bcb3635a9cab4238f55e1d48bd51849d24a252ba210d7e5bd69e51e.jpeg",
  ],
  priceDollars: 9.27,
  description:
    "Type: Earrings\nMaterial : Stainless steel ，Zircon，18K gold plated\nSize :18mm*28mm\nProcess: Vacuum electroplating and manual polishing,Non tarnish\nSurface : High Polish\n★Made of high quality stainless steel,Lead-free,Harmless to Human Body.\n★Perfect jewelry gifts ",
  tags: [],
  msrpDollars: 18.53,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:50.031Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
